import { store } from '../store/store'
//import applicationUserManager from '../SecurityService'

export function authHeader() {
    let user = store.getters.token;
    return {
        'Authorization': 'Bearer ' + user
    };
}

//function accessToken() {
//    applicationUserManager.getUser().then((data) => {
//        return data.access_token;
//    });
//}

export function authHeaderPost() {
    let user = store.getters.token;
    if (user) {
        return {
            'Authorization': 'Bearer ' + user,
            'Content-Type': 'multipart/form-data'
        };
    } else {
        return {};
    }
}
export function authHeaderPostForm() {
    let user = store.getters.token;
    if (user) {
        return {
            'Authorization': 'Bearer ' + user,
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    } else {
        return {};
    }
}

export function authHeaderjson() {
    // return authorization header with jwt token and content type
    let user = store.getters.token;
    if (user) {
        return {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + user
            
        };
    } else {
        return {};
    }
}

export function checkLinkMode() {
    let enabled = store.getters.LINKMODE;
    if (enabled) {
        return true;
    }
    else {
        return false;
    }
}

export function getObjectType(type) {
    if (type === 'DC')
        return 'DOCUMENTS';
    if (type === 'PN')
        return 'PERSONS';
    if (type === 'OG')
        return 'ORGANIZATIONS';
    if (type === 'EV')
        return 'EVENTS';
    if (type === 'RE')
        return 'REAL ESTATE';
    if (type === 'TR')
        return 'TRANSPORTATION';
}

export function setObject2Link(id, type){
    store.commit('addobject2Link', {id : id , type: type})
}
